"use client";

import { cn } from "@faire/react/tools/cn";
import { ButtonBase } from "@faire/slate/private/button/ButtonBase";
import { useHandleKeyDown } from "@faire/slate/private/hooks/useHandleKeyDown";
import React, { useRef } from "react";

type IProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  onClick?: () => void;
  onEscape?: () => void;
};

export const ToastCtaButton: React.FC<React.PropsWithChildren<IProps>> = ({
  children,
  className,
  onEscape,
  ...props
}) => {
  const buttonRef = useRef<HTMLButtonElement>(null);

  useHandleKeyDown({
    Escape: onEscape,
  });

  return (
    <ButtonBase
      className={cn(
        "fs-button",
        "fs-button--plain",
        "fs-toast__cta",
        className
      )}
      {...props}
      ref={buttonRef}
    >
      {children}
    </ButtonBase>
  );
};
